const BASE_URL = process.env.PUBLIC_URL;

// Define all possible paths for reference (adjust if new top-level/sub-menu items are added)
const allPaths = [
    `${BASE_URL}/dashboard`,
    `${BASE_URL}/callform/new-callform`,
    `${BASE_URL}/callform/pending-callform`,
    `${BASE_URL}/todo-list`,
    `${BASE_URL}/expenses`,
    `${BASE_URL}/payment-collections`,
    `${BASE_URL}/customers`,
    `${BASE_URL}/license-plates`,
    `${BASE_URL}/accidents`,
    `${BASE_URL}/accident-files`,
    `${BASE_URL}/enforcements`,
    `${BASE_URL}/compensations`,
    `${BASE_URL}/insurance-companies`,
    `${BASE_URL}/banks`,
    `${BASE_URL}/file-types`,
    `${BASE_URL}/workfile-types`,
    `${BASE_URL}/report-types`,
    `${BASE_URL}/cities`,
    `${BASE_URL}/districts`,
    `${BASE_URL}/arbitrators`,
    `${BASE_URL}/expert-witnesses`,
    `${BASE_URL}/dictionary-variables`,
    `${BASE_URL}/job-pool`,
    `${BASE_URL}/employees`,
    `${BASE_URL}/announcements`,
    `${BASE_URL}/arbitrations`,
    `${BASE_URL}/sample-page`, // Covers both instances
];

// Define paths to exclude for certain roles
const callFormPaths = [
    `${BASE_URL}/callform/new-callform`,
    `${BASE_URL}/callform/pending-callform`,
];

// Configuration mapping roles to allowed menu paths
const roleMenuConfig = {
    'CALL CENTER': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/callform/new-callform`,
        `${BASE_URL}/callform/pending-callform`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
    ],
    'HEAD CALL CENTER': [], // Will be assigned CALL CENTER's config
    'APPRAISER': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ],
    'HEAD APPRAISER': [], // Will be assigned APPRAISER's config
    'MANAGEMENT': 'ALL_EXCEPT_CALLFORM', // Special flag
    'ACCOUNTING': [ // Includes Finansal İşlemler based on assumption
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/expenses`,
        `${BASE_URL}/payment-collections`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ],
    'HEAD ACCOUNTING': [ // Includes Finansal İşlemler based on assumption
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/expenses`,
        `${BASE_URL}/payment-collections`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ],
    'POWER OF ATTORNEY REGISTRATION': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
    ],
    'DOCUMENT REQUEST': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ],
    'COORDINATOR': 'ALL_EXCEPT_CALLFORM', // Special flag
    'INSURANCE': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ], // No specific access defined
    'ADMIN': 'ALL', // Special flag for full access
    'LAWYER': [], // No specific access defined
    'ARBITRATION LAWYER': [ // Dashboard, Todo List ve Müşteri alanları
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
    ],
    'ENFORCEMENT PROCESSORS': [ // Dashboard, Todo List ve Müşteri alanları
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
        `${BASE_URL}/expenses`,
        `${BASE_URL}/payment-collections`,
    ],
    'HEAD ENFORCEMENT': [ // Dashboard, Todo List ve Müşteri alanları
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
        `${BASE_URL}/expenses`,
        `${BASE_URL}/payment-collections`,

    ],
    'COMPENSATION OFFICER': [
        `${BASE_URL}/dashboard`,
        `${BASE_URL}/todo-list`,
        `${BASE_URL}/customers`,
        `${BASE_URL}/license-plates`,
        `${BASE_URL}/accidents`,
        `${BASE_URL}/accident-files`,
        `${BASE_URL}/enforcements`,
        `${BASE_URL}/expenses`,
        `${BASE_URL}/payment-collections`,
    ],
    'DEFAULT': [] // Default role has no access
};

// Assign configurations for roles that mirror others
roleMenuConfig['HEAD CALL CENTER'] = roleMenuConfig['CALL CENTER'];
roleMenuConfig['HEAD APPRAISER'] = roleMenuConfig['APPRAISER'];

// Function to get the list of visible paths based on role
const getVisiblePaths = (role) => {
    const config = roleMenuConfig[role] || roleMenuConfig['DEFAULT'];
    if (config === 'ALL') {
        return allPaths;
    }
    if (config === 'ALL_EXCEPT_CALLFORM') {
        return allPaths.filter(path => !callFormPaths.includes(path));
    }
    // Return the array of paths or an empty array
    return Array.isArray(config) ? config : [];
};

// Function to recursively filter menu items based on a set of visible paths
const filterMenuItems = (menuItems, visiblePathsSet) => {
    return menuItems
        .map(section => {
            // Filter items within the section
            const filteredItems = section.Items.map(item => {
                if (item.type === 'link') {
                    // Keep link if its path is visible
                    return visiblePathsSet.has(item.path) ? item : null;
                } else if (item.type === 'sub') {
                    // Keep submenu if any of its children are visible
                    const visibleChildren = item.children.filter(child => visiblePathsSet.has(child.path));
                    if (visibleChildren.length > 0) {
                        // Return the submenu with only visible children
                        return { ...item, children: visibleChildren };
                    }
                    // Hide submenu if no children are visible
                    return null;
                }
                // Keep items that don't have a 'type' (like titles) or handle other types if necessary
                // For now, assume only 'link' and 'sub' with paths need checking
                return item; // Or null if other types should also be filterable based on role
            }).filter(item => item !== null); // Remove items marked as null (hidden)

            // If the section still has items after filtering, keep the section
            if (filteredItems.length > 0) {
                return { ...section, Items: filteredItems };
            }
            // Hide the section if it has no visible items
            return null;
        })
        .filter(section => section !== null); // Remove sections marked as null (hidden)
};


// Original Full Menu Structure (keep this as the source)
const FULL_MENUITEMS = [
    {
        menutitle: 'SAYFALAR',
        menucontent: 'Dashboards,Widgets',
        Items: [
            { path: `${process.env.PUBLIC_URL}/dashboard`, icon: "home", type: "link", title: "Ana Sayfa" },
            {
                title: 'Çağrı Formları',
                icon: 'form',
                type: 'sub',
                children: [
                    { path: `${process.env.PUBLIC_URL}/callform/new-callform`, title: 'Yeni Çağrı Formu Oluştur', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/callform/pending-callform`, title: 'Bekleyen Çağrı Formları', type: 'link', active: false },
                ],
            },
            { path: `${process.env.PUBLIC_URL}/todo-list`, icon: "to-do", type: "link", title: "İş Listesi" },
            {
                title: 'Finansal İşlemler',
                icon: 'task',
                type: 'sub',
                children: [
                    { path: `${process.env.PUBLIC_URL}/expenses`, title: 'Masraflar', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/payment-collections`, title: 'Tahsilatlar', type: 'link', active: false },
                ],
            },
        ],
    },
    {
        menutitle: 'MÜŞTERİ ALANLARI',
        menucontent: 'Dashboards,Widgets',
        Items: [
            { path: `${process.env.PUBLIC_URL}/customers`, icon: "user", type: "link", title: "Müşteriler" },
            { path: `${process.env.PUBLIC_URL}/license-plates`, icon: "landing-page", type: "link", title: "Plakalar" },
            { path: `${process.env.PUBLIC_URL}/accidents`, icon: "project", type: "link", title: "Kazalar" },
            { path: `${process.env.PUBLIC_URL}/accident-files`, icon: "builders", type: "link", title: "Kaza Dosyaları" },
            { path: `${process.env.PUBLIC_URL}/enforcements`, icon: "task", type: "link", title: "İcralar" },
            { path: `${process.env.PUBLIC_URL}/compensations`, icon: "task", type: "link", title: "Kapaklar" },
        ],
    },
    {
        menutitle: 'HAZIR GİRDİ ALANLARI',
        menucontent: 'Dashboards,Widgets',
        Items: [
            { path: `${process.env.PUBLIC_URL}/insurance-companies`, icon: "social", type: "link", title: "Sigorta Şirketleri" },
            { path: `${process.env.PUBLIC_URL}/banks`, icon: "animation", type: "link", title: "Bankalar" },
            {
                title: 'Kişi Tanımları',
                icon: 'others',
                type: 'sub',
                children: [
                    { path: `${process.env.PUBLIC_URL}/arbitrators`, title: 'Hakem Tanımları', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/expert-witnesses`, title: 'Bilirkişi Tanımları', type: 'link', active: false },
                ],
            },
            {
                title: 'Türler',
                icon: 'others',
                type: 'sub',
                children: [
                    { path: `${process.env.PUBLIC_URL}/file-types`, title: 'Evrak Türleri', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/workfile-types`, title: 'Dosya Türleri', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/report-types`, title: 'Rapor Türleri', type: 'link', active: false },
                ],
            },
            {
                title: 'Şehirler ve İlçeler',
                icon: 'maps',
                type: 'sub',
                children: [
                    { path: `${process.env.PUBLIC_URL}/cities`, title: 'Şehirler', type: 'link', active: false },
                    { path: `${process.env.PUBLIC_URL}/districts`, title: 'İlçeler', type: 'link', active: false },
                ],
            },
            { path: `${process.env.PUBLIC_URL}/dictionary-variables`, icon: "others", type: "link", title: "Sabit Değişkenler" },
        ],
    },
    {
        menutitle: 'YÖNETİM ALANLARI',
        menucontent: 'Dashboards,Widgets',
        Items: [
            { path: `${process.env.PUBLIC_URL}/job-pool`, icon: "task", type: "link", title: "İş Havuzu" },
            { path: `${process.env.PUBLIC_URL}/employees`, icon: "user", type: "link", title: "Çalışanlar" },
            { path: `${process.env.PUBLIC_URL}/announcements`, icon: "calendar", type: "link", title: "Duyurular" },
            //{ path: `${process.env.PUBLIC_URL}/sample-page`, icon: "contact", type: "link", title: "İletişim Geçmişleri (!)" },
            //{ path: `${process.env.PUBLIC_URL}/sample-page`, icon: "charts", type: "link", title: "Finansal İstatistikler (!)" },
        ],
    },
];

// --- End Role-based Menu Filtering Logic ---

// Helper function to trigger menu refresh after role changes
export const refreshMenuAfterRoleChange = () => {
    // Dispatch custom event to notify components about role change
    window.dispatchEvent(new CustomEvent('userRoleChanged'));
};

// Function to get current menu items dynamically based on current localStorage
export const getMenuItems = (customRole = null) => {
    // Get user role from localStorage at runtime, not at module load time
    const currentUserRole = customRole || localStorage.getItem('userRole');
    const roleVisiblePaths = getVisiblePaths(currentUserRole);
    const roleVisiblePathsSet = new Set(roleVisiblePaths);
    return filterMenuItems(FULL_MENUITEMS, roleVisiblePathsSet);
};

// Export a function that returns current menu items (for backward compatibility)
export const MENUITEMS = () => getMenuItems();
